import React, { useEffect, useState, useContext } from 'react';
import axios from '../../api/axiosInstance';
import { toast } from 'react-toastify';
import { AuthContext } from '../../context/AuthContext';
import './AssignUserToGroup.css'; // ✅ import the new CSS file

const AssignUserToGroup = () => {
  const [users, setUsers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');
  const { setCurrentGroup } = useContext(AuthContext);

  const fetchData = async () => {
    try {
      const [usersRes, groupsRes] = await Promise.all([
        axios.get('/users'),
        axios.get('/groups'),
      ]);
      setUsers(usersRes.data);
      setGroups(groupsRes.data);
    } catch (err) {
      toast.error('Failed to load users or groups');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

const handleAssign = async () => {
  if (!selectedUser || !selectedGroup) {
    toast.warning('Please select both a user and a group.');
    return;
  }

  try {
    await axios.post('/users/assign-group', {
      userId: selectedUser,
      groupId: selectedGroup,
    });
    toast.success('✅ User successfully assigned to group.');
    await fetchData();
  } catch (err) {
    const status = err.response?.status;
    const message = err.response?.data?.message;

    if (status === 409) {
      toast.info('ℹ️ User is already assigned to this group.');
    } else {
      toast.error(message || '❌ Failed to assign user.');
    }
  }
};

  const handleRefreshGroups = async () => {
    try {
      const response = await axios.get('/groups');
      setGroups(response.data);
      toast.info('Groups list refreshed.');
    } catch {
      toast.error('Failed to refresh groups.');
    }
  };

  const handleGroupChange = (e) => {
    const groupId = e.target.value;
    setSelectedGroup(groupId);
    const fullGroup = groups.find((g) => g._id === groupId);
    if (fullGroup) {
      setCurrentGroup(fullGroup);
    }
  };

  return (
    <div className="assign-container">
      <h2 className="assign-title">Assign User to Group</h2>

      <div className="assign-label-row">
        <label className="assign-label">Select Group:</label>
        <button className="refresh-btn" onClick={handleRefreshGroups}>
          Refresh Groups
        </button>
      </div>

      <select className="assign-select" value={selectedGroup} onChange={handleGroupChange}>
        <option value="">-- Choose a Group --</option>
        {groups.map((group) => (
          <option key={group._id} value={group._id}>
            {group.name}
          </option>
        ))}
      </select>

      <div className="assign-input-group">
        <label className="assign-label">Select User:</label>
        <select
          className="assign-select"
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}
        >
          <option value="">-- Choose a User --</option>
          {users.map((user) => (
            <option key={user._id} value={user._id}>
              {user.name || user.email}
            </option>
          ))}
        </select>
      </div>

      <button className="assign-btn" onClick={handleAssign}>
        Assign
      </button>
    </div>
  );
};

export default AssignUserToGroup;
